<template>
  <div class="body">
    <Header />

    <div class="container mt-5 mb-5">
      <div class="row justify-content-center">
        <div class="form col-md-8">
          <div class="form-wrapper">
            <h2 class="form-title text-center mb-4">Contáctanos</h2>

            <!-- Formulario -->
            <form @submit.prevent="submitContactForm" class="contact-form">
              <!-- Fila 1: Nombre, Apellido, Correo -->
              <div class="row mb-4">
                <div class="col-md-4 form-group">
                  <label for="name" class="form-label">Nombre</label>
                  <input type="text" id="name" v-model="form.name" class="form-control" placeholder="Tu nombre"
                    required />
                </div>

                <div class="col-md-4 form-group">
                  <label for="lastname" class="form-label">Apellido</label>
                  <input type="text" id="lastname" v-model="form.lastname" class="form-control"
                    placeholder="Tu apellido" required />
                </div>

                <div class="col-md-4 form-group">
                  <label for="email" class="form-label">Correo Electrónico</label>
                  <input type="email" id="email" v-model="form.email" class="form-control"
                    placeholder="tucorreo@ejemplo.com" required />
                </div>
              </div>

              <!-- Fila 2: Teléfono, Asunto -->
              <div class="row  mb-4">
                <div class="col-md-6 form-group">
                  <label for="phone" class="form-label">Teléfono</label>
                  <div class="input-group d-flex">
                    <select v-model="form.phonePrefix" class="form-select"
                      style="max-width: 90px; border-top-right-radius: 0; border-bottom-right-radius: 0;">
                      <option value="+58">+58</option>
                      <option value="+1">+1</option>
                    </select>
                    <input type="tel" id="phone" v-model="form.phoneNumber" class="form-control"
                      placeholder="Número de teléfono" style="border-top-left-radius: 0; border-bottom-left-radius: 0;"
                      required />
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  <label for="subject" class="form-label">Asunto</label>
                  <input type="text" id="subject" v-model="form.subject" class="form-control"
                    placeholder="Asunto del mensaje" />
                </div>
              </div>

              <!-- Fila 3: Mensaje -->
              <div class="row">
                <div class="col-md-12 form-group">
                  <label for="message" class="form-label">Mensaje</label>
                  <textarea id="message" v-model="form.message" class="form-control"
                    placeholder="Escribe tu mensaje aquí..." rows="6" required></textarea>
                </div>
              </div>

              <!-- Botón de Enviar -->
              <div class="form-group text-center">
                <button type="submit" class="btn btn-primary">
                  Enviar Mensaje
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Scroll to top -->
    <a href="#" class="scroll-top">
      <i class="lni lni-chevron-up"></i>
    </a>
  </div>
</template>



<script>
import Header from "@/components/Header.vue";
import Swal from "sweetalert2";
import EventBus from "@/EventBus";
import { config } from "@/config"; // Importar la configuración

export default {
  name: "Contacto",
  components: {
    Header,
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        subject: "",
        message: "",
        phonePrefix: "+58",
        phoneNumber: ""
      },
    };
  },
  computed: {},
  async mounted() { },
  methods: {
    async submitContactForm() {
      try {
        // Aquí puedes agregar la lógica para enviar los datos del formulario a un backend o servicio de correo
        Swal.fire(
          "Enviado",
          "Tu mensaje ha sido enviado con éxito.",
          "success"
        );

        // Limpiar el formulario después de enviarlo
        this.form = { name: "", email: "", subject: "", message: "" };
      } catch (error) {
        Swal.fire(
          "Error",
          "Hubo un problema al enviar el mensaje. Intenta de nuevo.",
          "error"
        );
      }
    },
  },
};
</script>

<style scoped>
.form {
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
}

.body {
  background-color: #f9f9f9;
  ;
}
</style>
